import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
import { guaranteeSteps } from '../data/content';
export function Guarantee() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-163" data-mp="223y3r2zr1zi0">
      <div className="mx-auto max-w-3xl" data-id="element-164" data-mp="1x4l9vyagns5x">
        <div className="rounded-3xl bg-radar-light p-6 ring-1 ring-radar/30 sm:p-10" data-id="element-165" data-mp="1x4uz3jnolvak">
          <div className="flex flex-col items-center text-center" data-id="element-166" data-mp="19fsh2ap4y0fj">
            <span className="flex h-24 w-24 items-center justify-center rounded-full bg-navy-900 ring-4 ring-radar" data-id="element-167" data-mp="14fxtoh4kjsz8">
              <ShieldCheckIcon className="h-12 w-12 text-radar" aria-hidden="true" data-id="element-168" data-mp="1j4tw9ynuwdsg" />
            </span>
            <p className="mt-5 text-sm font-bold uppercase tracking-widest text-radar-deep" data-id="element-169" data-mp="1ecsqmvl71lbe">
              7-day "try it yourself" guarantee
            </p>
            <h2 id="guarantee-title" className="mt-2 font-display text-4xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-170" data-mp="qlwtrk1vrzxa">
              Review it. Use it. Decide.
            </h2>
          </div>

          <div className="mt-8 space-y-4 text-lg leading-relaxed text-ink" data-id="element-171" data-mp="txbficdtwn9p">
            <p data-id="element-172" data-mp="yot7iaxvjdij">
              I don't want you to buy Implant Risk Radar™ wondering whether it will actually be useful to you. So
              here's what I recommend:
            </p>
            <ul className="grid gap-2.5 sm:grid-cols-2" data-id="element-173" data-mp="60xb77c7vnma">
              {guaranteeSteps.map(s => <li key={s} className="flex items-center gap-2.5 rounded-xl bg-white p-3.5" data-id="element-174" data-mp="azh11itxljjx">
                  <CheckIcon className="h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-175" data-mp="f1ln9wi1vdwj" />
                  <span className="text-[16px] font-medium" data-id="element-176" data-mp="k06nhvxaxxkz">{s}</span>
                </li>)}
            </ul>
            <p data-id="element-177" data-mp="1qfh4dasilwqe">And decide for yourself whether this system deserves a place in your clinical reference library.</p>
            <p className="font-semibold" data-id="element-178" data-mp="1vealreaxa7vu">
              If within the first 7 days you decide that Implant Risk Radar™ isn't right for you, simply contact us and
              we'll refund 100% of your purchase.
            </p>
            <p className="text-muted" data-id="element-179" data-mp="3nj7rdkopownt">
              No complicated process. No unnecessary questions. Just a straightforward guarantee.
            </p>
          </div>
        </div>

        <SectionCta label="Try Implant Risk Radar™ risk-free for 7 days" data-id="element-180" data-mp="d8g1fqx8met" />
      </div>
    </section>;
}